export default __webpack_public_path__ + "static/media/user.ebc85f4f.png";